"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({ entryVars: { objectTo }, }) => JSON.stringify(objectTo);
